import './App.css';
import HomePage from './pages/HomePage';
import CareerPage from './pages/CareerPage';
import AutoPage from './pages/AutoPage'; // Import AutoPage
import Header from './components/Header';
import Footer from './components/Footer';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import TermsAndConditions from './pages/TermsAndConditions';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ScrollToTop from './components/ScrollToTop'; // Import the ScrollToTop component


function App() {
  return (
    <Router>
      <div className="app-layout">
        <Header />
        <div className="main-content">
          <ScrollToTop>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/careers" element={<CareerPage />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/termsandconditions" element={<TermsAndConditions />} />
            <Route path="/auto" element={<AutoPage />} /> {/* Add AutoPage Route */}

          </Routes>
          </ScrollToTop>
         
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
